import { Routes } from '@angular/router';
import { ErrorComponent } from './shared/components/error/error.component';
import { LoginComponent } from './shared/components/login/login.component';
import { HelpCenterComponent } from './shared/components/help-center/help-center.component';
import { SettingsComponent } from './shared/components/settings/settings.component';
import { TryNowComponent } from './shared/components/try-now/try-now.component';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { TryNowViewComponent } from './shared/components/try-now-view/try-now-view.component';
import { RepoRequestComponent } from './modules/admin/repo-request/repo-request.component';
import { ResetPasswordComponent } from './shared/components/reset-password/reset-password.component';

export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path:'login', component:LoginComponent},
    { path:'help', component:HelpCenterComponent},
    { path:'resetPassword', component:ResetPasswordComponent},
    { path:'tryNow', component:LayoutComponent, children:[
        {path:'', component:TryNowComponent, data:{name:'Website Try Now'}}
    ]},    
    { path:'tryNow-View', component:LayoutComponent, children:[
        {path:'', component:TryNowViewComponent, data:{name:'Website Try Now'}}
    ]},
    { path:'settings', component:LayoutComponent, children:[
        {path:'', component:SettingsComponent, data:{name:'Settings'}}
    ]},
    { path:'repoRequest', component:LayoutComponent, children:[
        {path:'', component:RepoRequestComponent, data:{name:'Repo Request'}}
    ]},
    { path:'project', loadChildren: () => import('./modules/project/project.module').then((a) => a.ProjectModule)},
    { path:'client', loadChildren: () => import('./modules/client/client.module').then((b) => b.ClientModule)},
    { path:'admin', loadChildren: () => import('./modules/admin/admin.module').then( (c) => c.AdminModule)},
    { path:'ai-admin', loadChildren: () => import('./modules/ai-admin/ai-admin.module').then( (d) => d.AiAdminModule)},
    { path:'dba', loadChildren: () => import('./modules/dba/dba.module').then( (e) => e.DbaModule)},
    { path: '**', component: ErrorComponent },
    { path: 'error', component: ErrorComponent },
];
